export default class Storitev {
  _idPrikljucekStoritev
  _idPrikljucek = null
  _idStoritev = null
  _idVrsta = null
  _cena = null
  _kolicina = null
  _konfPod3 = null
  _narocenoNaVmesniku = null
  _naziv = null
  _opis = null
  _status = null
  _statusId = null
  _trajanjeDo = null
  _trajanjeOd = null
  _vPaketu = null
  _vklopljena = false
  _narocena = false

  static parseFromResponseItem (item, vklopljena) {
    let out = new this()
    out._idPrikljucekStoritev = Number.parseInt(item.idPrikljucekStoritev)
    out._idPrikljucek = Number.parseInt(item.idPrikljucek)
    out._idStoritev = Number.parseInt(item.idStoritev)
    out._idVrsta = Number.parseInt(item.idVrsta)
    out._cena = Number.parseFloat(item.cena)
    out._kolicina = Number.parseInt(item.kolicina)
    try {
      out._konfPod3 = JSON.parse(item.konfPod3)
    } catch (e) {
      out._konfPod3 = null
    }
    out._narocenoNaVmesniku = item.narocenoNaVmesniku
    out._naziv = item.naziv
    out._opis = item.opis
    out._status = item.status
    out._statusId = Number.parseInt(item.statusId)
    out._trajanjeDo = item.trajanjeDo
    out._trajanjeOd = item.trajanjeOd
    out._vPaketu = item.vPaketu
    if (vklopljena) {
      out._vklopljena = true
    } else {
      out._narocena = true
    }
    return out
  }

  get idPrikljucekStoritev () {
    return this._idPrikljucekStoritev
  }

  set idPrikljucekStoritev (value) {
    this._idPrikljucekStoritev = value
  }

  get idPrikljucek () {
    return this._idPrikljucek
  }

  set idPrikljucek (value) {
    this._idPrikljucek = value
  }

  get idStoritev () {
    return this._idStoritev
  }

  set idStoritev (value) {
    this._idStoritev = value
  }

  get idVrsta () {
    return this._idVrsta
  }

  set idVrsta (value) {
    this._idVrsta = value
  }

  get cena () {
    return this._cena
  }

  set cena (value) {
    this._cena = value
  }

  get kolicina () {
    return this._kolicina
  }

  set kolicina (value) {
    this._kolicina = value
  }

  get konfPod3 () {
    return this._konfPod3
  }

  set konfPod3 (value) {
    this._konfPod3 = value
  }

  get narocenoNaVmesniku () {
    return this._narocenoNaVmesniku
  }

  set narocenoNaVmesniku (value) {
    this._narocenoNaVmesniku = value
  }

  get naziv () {
    return this._naziv
  }

  set naziv (value) {
    this._naziv = value
  }

  get opis () {
    return this._opis
  }

  set opis (value) {
    this._opis = value
  }

  get status () {
    return this._status
  }

  set status (value) {
    this._status = value
  }

  get statusId () {
    return this._statusId
  }

  set statusId (value) {
    this._statusId = value
  }

  get trajanjeDo () {
    return this._trajanjeDo
  }

  set trajanjeDo (value) {
    this._trajanjeDo = value
  }

  get trajanjeOd () {
    return this._trajanjeOd
  }

  set trajanjeOd (value) {
    this._trajanjeOd = value
  }

  get vPaketu () {
    return this._vPaketu
  }

  set vPaketu (value) {
    this._vPaketu = value
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/Storitve/Storitev.js